import { render, staticRenderFns } from "./historyVersionDialog.vue?vue&type=template&id=b20174e8&scoped=true&"
import script from "./historyVersionDialog.vue?vue&type=script&lang=js&"
export * from "./historyVersionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20174e8",
  null
  
)

export default component.exports